import { IOffer } from "@types";

import { Badge } from "./Badge";

/** Passed as the antd Drawer's `title`, so it gets the built-in close button for free. */
export function AdvisorHeader({
  offer,
  isComplete,
}: {
  offer?: Partial<IOffer> | null;
  isComplete: boolean;
}) {
  const candidateName = offer?.offer_candidate_detail?.candidate_name;
  const jobTitle = offer?.offer_position_detail?.job_title;

  return (
    <div className="flex items-center justify-between gap-3 pr-6">
      <div className="min-w-0">
        <div className="truncate text-base font-semibold text-gray-800">
          {candidateName || (offer?.id ? `Offer #${offer.id}` : "AI Advisor")}
        </div>
        <div className="truncate text-xs font-normal text-gray-500">
          {jobTitle || "Advisory session"}
        </div>
      </div>
      {isComplete && <Badge variant="success">Complete</Badge>}
    </div>
  );
}
